// Global Types
import type {
  $MandatoryConfigParams,
} from 'common.helpers';

// Global Enums
import {
  DeploymentEnvironment,
} from 'common.enums';

// Helpers
import {
  getConfig,
  validateConfigParams,
} from 'common.helpers/dist/browser';
import packageJson from '../package.json';

// Types
export type $Config = {
  API_URL: string;
  AUTH_FACEBOOK_APP_ID: string;
  AUTH_GOOGLE_CLIENT_ID: string;
  CDN_URL: string;
  CRISP_WEBSITE_ID: string;
  DEPLOYMENT_ENV: DeploymentEnvironment;
  DOMAIN: string;
  GOOGLE_MAPS_API_KEY: string;
  MIXPANEL_TOKEN: string;
  RECAPCHA_SITE_KEY: string;
  SENTRY_DSN: string;
  SOCKET_HOST: string;
  STRIPE_PUBLISHABLE_KEY: string;
  TIMEOUT: string;
  TRACKER_API_URL: string;
};

const params: Array<keyof $Config> = [
  'API_URL',
  'AUTH_FACEBOOK_APP_ID',
  'AUTH_GOOGLE_CLIENT_ID',
  'CDN_URL',
  'CRISP_WEBSITE_ID',
  'DEPLOYMENT_ENV',
  'DOMAIN',
  'GOOGLE_MAPS_API_KEY',
  'MIXPANEL_TOKEN',
  'RECAPCHA_SITE_KEY',
  'SENTRY_DSN',
  'SOCKET_HOST',
  'STRIPE_PUBLISHABLE_KEY',
  'TIMEOUT',
  'TRACKER_API_URL',
];

const mandatoryConfigParams: $MandatoryConfigParams<$Config> = {
  [DeploymentEnvironment.development]: ['API_URL', 'DEPLOYMENT_ENV'],
  [DeploymentEnvironment.production]: ['API_URL', 'DEPLOYMENT_ENV'],
  [DeploymentEnvironment.test]: ['DEPLOYMENT_ENV'],
};

const config: $Config = getConfig({
  params,
});

const validConfig = validateConfigParams<$Config>({
  config,
  mandatoryConfigParams,
});

export const packageName: string = packageJson.name || 'Unknown package';

export const packageVersion: string = packageJson.version || 'Unknown version';

export default validConfig;
